"use client";

import { USER_PROFILE_API } from "@/lib/constants";
import { useQuery } from "@tanstack/react-query";
import UpdateProfileForm from "./components/update-profile-form";
import UpdateProfileFormLoadingState from "./components/update-profile-form-loading";

export type TProfileUpdateFormData = {
	profilePicture: string;
	name?: string;
	username?: string;
	bio?: string;
	location?: string;
	categories?: string[];
	jobTitle?: string;
	company?: string;
	howDoYouIdentifyYourself?: string | null;
	socialLinks: {
		personalWebsite?: string | null;
		linkedin?: string;
		instagram?: string | null;
		twitter?: string | null;
	};
};

const getProfileDetails = async () => {
	const response = await fetch(USER_PROFILE_API);
	const { data } = (await response.json()) as { data: TProfileUpdateFormData };

	return data;
};

const UpdateProfile = () => {
	const { data: profileDetails, isLoading } = useQuery({
		queryKey: ["updateProfileDetails"],
		queryFn: getProfileDetails,
		refetchOnMount: false,
	});

	const prefillData = {
		...profileDetails,
		profilePicture: profileDetails?.profilePicture ? profileDetails.profilePicture : "",
		socialLinks: {
			...profileDetails?.socialLinks,
			linkedin: profileDetails?.socialLinks?.linkedin ? profileDetails.socialLinks.linkedin : "",
		},
	};

	return (
		<>
			{isLoading ? (
				<UpdateProfileFormLoadingState />
			) : profileDetails ? (
				<UpdateProfileForm prefillProfileData={prefillData} />
			) : null}
		</>
	);
};

export default UpdateProfile;
